import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import Loading from "../../components/Loading/Loading";
import axios from "axios";
import ProfessionalCard from "../../components/ProfessionalCard/ProfessionalCard";
import styles from "./RandBView.module.css";

const RandBView = () => {
  const [professionals, setProfessionals] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    showings: false,
    instagram: false,
  });

  useEffect(() => {
    const fetchRealtors = async () => {
      try {
        const requestData = { filters };

        const response = await axios.post(
          `${import.meta.env.VITE_BACKEND_URL}/professional/list`,
          requestData,
          {
            headers: {},
          }
        );

        if (response.status === 200 && response.data.success) {
          setProfessionals(response.data.professionals);
        } else {
          console.error(response.data.error || "Error fetching professionals");
        }

        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        console.error("Error:", error);
      }
    };

    fetchRealtors();
  }, [filters]);

  const handleFilterChange = (e) => {
    const { name, checked } = e.target;
    setFilters((prev) => ({ ...prev, [name]: checked }));
  };

  const handleCardCick = (slug) => {
    window.open(`/Realtors-and-Brokers/${slug}`, "_blank");
  };

  return (
    <>
      <Navbar />
      <div>
        {isLoading ? (
          <div className={styles.loadingContainer}>
            <Loading />
          </div>
        ) : (
          <div className={styles.realtorListContainer}>
            <div className={styles.realtorList}>
              {professionals.map((professional, id) => (
                <div
                  key={id}
                  onClick={() => handleCardCick(professional.slug)}
                  className={styles.realtorCard}
                >
                  <ProfessionalCard
                    image={professional.photo_url}
                    name={
                      professional.first_name + " " + professional.last_name
                    }
                    instagram={professional.instagram}
                    showings={professional.showings}
                    myProperties={professional.active_listings_cnt || 0}
                    isBroker={
                      professional.broker_license_verified_at ? true : false
                    }
                    isRealtor={
                      professional.realtor_license_verified_at ? true : false
                    }
                    specialization={professional.specialization}
                    linkedinLink={professional.linkedin_link || null}
                    instagramLink={professional.instagram_link || null}
                    youtubeLink={professional.youtube_link || null}
                    tiktokLink={professional.tiktok_link || null}
                    licenses={professional.licenses || null}
                  />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default RandBView;
